import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const Terms = () => {
  return (
    <Box sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="md">
        <Typography variant="h3" component="h1" sx={{ fontWeight: 600, mb: 2 }}>
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last updated: {new Date().getFullYear()}
        </Typography>

        <Typography variant="body1" paragraph>
          These Terms of Service (&quot;Terms&quot;) govern how you may use the Rinovo website,
          web application, and related services (collectively, the &quot;Services&quot;).
        </Typography>
        <Typography variant="body1" paragraph>
          By accessing or using the Services, you agree to be bound by these Terms. If you do not
          agree to these Terms, do not use the Services.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          1. Using Rinovo
        </Typography>
        <Typography variant="body1" paragraph>
          You agree to use Rinovo only for lawful purposes and in a way that does not harm us,
          other users, or our service providers.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          2. Your Account
        </Typography>
        <Typography variant="body1" paragraph>
          To use certain features of the Services, you may need to create an account. You agree to
          provide accurate, current, and complete information and to keep your account information
          up to date. You are responsible for maintaining the confidentiality of your login
          credentials and for all activities that occur under your account.
        </Typography>
        <Typography variant="body1" paragraph>
          You must promptly notify us of any unauthorized use of your account or any other breach of
          security. Rinovo is not liable for any loss or damage arising from your failure to protect
          your account credentials.
        </Typography>
        <Typography variant="body1" paragraph>
          You agree that you will not:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ pl: 3, mb: 2 }}>
          <li>Use the Services for any unlawful purpose or in violation of any applicable law.</li>
          <li>
            Upload, share, or transmit any content that is infringing, deceptive, harmful, hateful,
            or otherwise objectionable.
          </li>
          <li>
            Attempt to probe, scan, or test the vulnerability of the Services or breach any
            security or authentication measures.
          </li>
          <li>
            Interfere with or disrupt the operation of the Services, including by introducing
            viruses, bots, or other malicious code.
          </li>
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          3. Your Content
        </Typography>
        <Typography variant="body1" paragraph>
          The Services may allow you to upload, submit, store, or share content such as images,
          text, product links, and notes (&quot;Your Content&quot;). You retain any rights you hold
          in Your Content.
        </Typography>
        <Typography variant="body1" paragraph>
          We use Your Content only as needed to operate and improve Rinovo, for example to process
          your searches, show results, and power saved items and boards.
        </Typography>
        <Typography variant="body1" paragraph>
          You are solely responsible for Your Content and for ensuring that you have all necessary
          rights to upload or share it. You represent and warrant that Your Content does not
          infringe or violate the rights of any third party or any law.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          4. Third-Party Content and Links
        </Typography>
        <Typography variant="body1" paragraph>
          The Services may display or link to third-party products, websites, or content that are
          not controlled by Rinovo. We do not endorse, monitor, or guarantee any third-party
          content, and your interactions with third parties are solely between you and the third
          party. Rinovo is not responsible for any loss or damage arising from your dealings with
          third parties.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          5. Our Content
        </Typography>
        <Typography variant="body1" paragraph>
          The Services, including all software, text, graphics, logos, and other content (excluding
          Your Content and third-party content), are owned by or licensed to Rinovo and are
          protected by copyright, trademark, and other laws. Except as expressly permitted in these
          Terms, you may not use, copy, reproduce, modify, or create derivative works based on the
          Services without our prior written consent.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          6. Changes to These Terms
        </Typography>
        <Typography variant="body1" paragraph>
          We may update these Terms from time to time. If we make material changes, we will post
          the updated Terms on this page and update the &quot;Last updated&quot; date above. Your
          continued use of the Services after the updated Terms become effective constitutes your
          acceptance of the changes.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mt: 4, mb: 2 }}>
          14. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about these Terms or the Services, please contact us at:
        </Typography>
        <Typography variant="body1" paragraph>Email: rinovoco@gmail.com</Typography>
      </Container>
    </Box>
  );
};

export default Terms;

